import { useEffect } from 'react';

import { exposePaywallExperiment, usePaywallExperimentStore } from '@/shared/lib/paywallExperiment';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

export const trackPaywallExposure = (feature: string) => {
  if (exposePaywallExperiment(feature)) MixpanelEvents.paywallExperimentShown();
};

export const usePaywallExperiment = (visibleFeature?: string) => {
  const variant = usePaywallExperimentStore((state) => state.variant);
  const userId = usePaywallExperimentStore((state) => state.userId);
  useEffect(() => {
    if (visibleFeature) trackPaywallExposure(visibleFeature);
  }, [visibleFeature, userId]);
  return userId ? variant : undefined;
};
